<div class="d-flex justify-content-between">
  <span class="comments-number"
    >{{ item[field]?.value || '0' }} {{ 'LeadPortal.distributor.quotes_sent.label' | translate }}</span
  >

  <i class="fas fa-chevron-right"></i>
</div>
